
import { getProductByID, toRollerShutter } from 'modules/shop-front/shop-front-component/ProductCollection'
import GenericProductPage from '../GenericProductPage'
export default function RS42mmDL() {

    return (
        GenericProductPage(getProductByID(66),toRollerShutter)
    )
  }
